declare global {
  interface Window {
    Affonso: {
      signup: (email: string) => void;
    };
  }
}

export const trackAffiliateSignup = async (email: string) => {
  if (typeof window !== 'undefined' && window.Affonso) {
    window.Affonso.signup(email);
  }
};

export const getAffiliateReferralId = () => {
  if (typeof document === 'undefined') return null;

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'affonso_referral') {
      return value;
    }
  }
  return null;
};
